import {isEmpty} from "../util/type-utils.js";
import {attachTouchClickEventListener} from "../util/event-utils.js";
import {toggleClass} from "@21torr/dune/dom/attrs.js";
import {resetAnimationsforElements} from "../micro-animation.js";


const SELECTOR_HELP_BUTTON = '.help-icon';
const SELECTOR_HELP_CONTENT = '.help-content';
const SELECTOR_CLOSE_BUTTON = '.help-close-button';

const CONTENT_VISIBLE_CLASS = 'help-open';


export function initFormHelp(container) {

    if (isEmpty(container)) {
        return;
    }

    const helpButton = container.querySelector(SELECTOR_HELP_BUTTON),
        helpContent = container.querySelector(SELECTOR_HELP_CONTENT),
        closeButton = container.querySelector(SELECTOR_CLOSE_BUTTON);

    if (isEmpty(helpButton)) {
        return;
    }

    const toggleBtn = () => {
        const show = !container.classList.contains(CONTENT_VISIBLE_CLASS);

        if (show) {
            closeAll();
        }


        toggleClass(container, CONTENT_VISIBLE_CLASS, show);
        resetAnimationsforElements(helpContent);
    };

    attachTouchClickEventListener(helpButton, toggleBtn);
    attachTouchClickEventListener(closeButton, (e) => {
        toggleBtn();
        e.stopPropagation();
    });
}

/**
 * Closes all visible help content containers
 */
function closeAll() {
    document.querySelectorAll(`.${CONTENT_VISIBLE_CLASS}`).forEach(container => {
        toggleClass(container, CONTENT_VISIBLE_CLASS, false);
    });


}